import { Link, useLocation } from "react-router-dom";
import { createWhatsAppUrl } from "../lib/format";
import { getLastBooking } from "../lib/storage";

export default function BookingSuccess() {
  const location = useLocation();
  const booking = location.state?.booking || getLastBooking();

  const whatsappHref = booking
    ? createWhatsAppUrl({
        tutorName: booking.tutorName,
        studentName: booking.studentName,
        mobile: booking.mobile,
        slot: booking.preferredSlot,
      })
    : "https://wa.me/919507505612";

  return (
    <section className="section-shell pt-16">
      <div className="surface-panel mx-auto max-w-4xl overflow-hidden p-8 text-center sm:p-10">
        <div className="eyebrow-light">Booking Success</div>
        <h1 className="headline mt-4">Your demo request has been saved</h1>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-8 text-slate-600">
          WhatsApp should already be open with your prefilled message. If it did not open, use the
          button below to try again.
        </p>

        {booking ? (
          <div className="mt-8 rounded-[28px] border border-slate-100 bg-slate-50 p-6 text-left">
            <div className="grid gap-4 sm:grid-cols-2">
              <div>
                <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-slate-400">Student</p>
                <p className="mt-1 font-semibold text-slate-700">{booking.studentName}</p>
              </div>
              <div>
                <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-slate-400">Tutor</p>
                <p className="mt-1 font-semibold text-slate-700">{booking.tutorName}</p>
              </div>
              <div>
                <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-slate-400">Mobile</p>
                <p className="mt-1 font-semibold text-slate-700">+91 {booking.mobile}</p>
              </div>
              <div>
                <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-slate-400">Preferred Slot</p>
                <p className="mt-1 font-semibold text-slate-700">{booking.preferredSlot}</p>
              </div>
            </div>
          </div>
        ) : null}

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <a href={whatsappHref} target="_blank" rel="noreferrer" className="button-primary">
            Open WhatsApp Again
          </a>
          <Link to="/marketplace" className="button-secondary">
            Browse Tutors
          </Link>
        </div>
      </div>
    </section>
  );
}
